import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum Visibility {
  Disabled = "Disabled",
  Enabled = "Enabled",
}

type Tab = "realtime" | "statistic"

type ExpertModeState =
  {
    enabled: boolean,
    selectedTab: Tab
  }

const initialState: ExpertModeState = {
  enabled: false,
  selectedTab: "realtime"
};

export const expertModeSlice = createSlice({
  name: "expertMode",
  initialState,
  reducers: {
    enable: (state) => {
      state.enabled = true;
    },
    disable: (state,) => {
      state.enabled = false;
    },
    selectTab: (state, action: PayloadAction<Tab>) => {
      state.selectedTab = action.payload;
    },
  },
});

export default expertModeSlice;
